export const operatorValues = ['eq', 'in', 'bt', 'ct', 'sw', 'ew', 'gt', 'gte', 'lt', 'lte']

export const textOperators = [
	{code: 'equals', label: 'gen.operators.equals', value: 'eq', not: false},
	{code: 'not-equals', label: 'gen.operators.notEquals', value: 'eq', not: true},
	{code: 'string-contains', label: 'gen.operators.stringContains', value: 'ct', not: false},
	{code: 'starts-with', label: 'gen.operators.startsWith', value: 'sw', not: false},
	{code: 'ends-with', label: 'gen.operators.endsWith', value: 'ew', not: false},
	{code: 'is-null', label: 'gen.operators.isNull', value: 'eq', not: false, null: true},
	{code: 'is-not-null', label: 'gen.operators.isNotNull', value: 'eq', not: true, null: true}
]
export const numberOperators = [
	{code: 'equals', label: 'gen.operators.equals', value: 'eq', not: false},
	{code: 'not-equals', label: 'gen.operators.notEquals', value: 'eq', not: true},
	{code: 'greater', label: '>', value: 'gt'},
	{code: 'greater-equal-to', label: '>=', value: 'gte'},
	{code: 'lesser', label: '<', value: 'lt'},
	{code: 'lesser-equal-to', label: '<=', value: 'lte'},
	{code: 'between', label: 'gen.operators.between', value: 'bt', not: false},
	{code: 'not-between', label: 'gen.operators.notBetween', value: 'bt', not: true},
	{code: 'is-null', label: 'gen.operators.isNull', value: 'eq', not: false, null: true},
	{code: 'is-not-null', label: 'gen.operators.isNotNull', value: 'eq', not: true, null: true}
]

export const selectOperators = [
	{code: 'equals', label: 'gen.operators.equals', value: 'eq', not: false},
	{code: 'not-equals', label: 'gen.operators.notEquals', value: 'eq', not: true},
	{code: 'in-array', label: 'gen.operators.in', value: 'in', not: false},
	{code: 'not-in-array', label: 'gen.operators.notIn', value: 'in', not: true},
	{code: 'is-null', label: 'gen.operators.isNull', value: 'eq', not: false, null: true},
	{code: 'is-not-null', label: 'gen.operators.isNotNull', value: 'eq', not: true, null: true}
]